import React from 'react';
import { FaTimes, FaShieldAlt } from 'react-icons/fa';
import FamilyPrivacySettings from '../FamilyPrivacySettings/FamilyPrivacySettings';
import './FamilyPrivacyModal.css';

const FamilyPrivacyModal = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    return (
        <div className="privacy-modal-overlay" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
            <div className="privacy-modal-container">
                <div className="privacy-modal-header">
                    <div className="privacy-modal-title">
                        <div className="privacy-icon-badge">
                            <FaShieldAlt />
                        </div>
                        <div>
                            <h2>Autorizações Familiares (RGPD 18+)</h2>
                            <p className="privacy-modal-subtitle">Gerir autorizações concedidas e pedidos pendentes de familiares</p>
                        </div>
                    </div>
                    <button className="privacy-modal-close" onClick={onClose} aria-label="Fechar">
                        <FaTimes />
                    </button>
                </div>

                <div className="privacy-modal-body">
                    <FamilyPrivacySettings />
                </div>
            </div>
        </div>
    );
};

export default FamilyPrivacyModal;
